import {useState} from 'react'

import type {HierarchyTableNode} from '../types'

export const useEditResponsibleUsers = () => {
  const [selectedItem, setSelectedItem] = useState<HierarchyTableNode>()

  const handleEditClick = (item: HierarchyTableNode) => {
    setSelectedItem(item)
  }

  return {
    handleEditClick,
    users: selectedItem?.responsibles || [],
    setSelectedItem,
    selectedItem
  } as const
}
